module.exports = __webpack_public_path__ + "html/section-feedback_91c0ab4b9c57530b8555b783ec942533.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-feedback.html
// module id = +kXM
// module chunks = 63